import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa"; // Importar el ícono de lupa
import dataMapaService from '../../services/dataMapa';
import TablaProyectos from './TablaProyectos';
import GraficosInversion from './GraficosInversion';

import { Tooltip, Modal, Button, Badge, Typography, List } from "antd";
import { DeleteOutlined, QuestionCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { BiBarChart } from 'react-icons/bi'; // Importar el ícono de gráficos


import './MapaCauca.css';
import MapaCaucaDepartamento from './MapaCaucaDepartamento';

import logo1 from "../../assets/images/logo_gobernacion.png";
import logo2 from "../../assets/images/logo_tangara.png";

import logogobernacion from "../../assets/images/logoGobernaciondelCauca.svg";
import Indeportes from "../../assets/images/Indeportes.svg";
import UNGRD from "../../assets/images/UNGRD.svg";
import emcaservicios from "../../assets/images/emcaservicios.jpg";

import Occidente from "../../assets/images/Occidente.svg";
import Sur from "../../assets/images/Sur.svg";
import Oriente from "../../assets/images/Oriente.svg";
import Norte from "../../assets/images/Norte.svg";
import Centro from "../../assets/images/Centro.svg";
import Cauca from "../../assets/images/Cauca.svg";



import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";


const { Title } = Typography;

const entidades = [
    "Emcaservicios",
    "Indeportes",
    "Oficina Asesora de Gestión del Riesgo",
    "Oficina Asesora de Planeación",
    "Oficina Asesora Jurídica",
    "Oficina de Gestión Social y Asuntos Poblacionales",
    "Secretaría de Agricultura y Desarrollo Rural",
    "Secretaría de Desarrollo Económico y Competitividad",
    "Secretaría de Educación y Cultura",
    "Secretaría de Gobierno y Participación",
    "Secretaría de Hacienda",
    "Secretaría de Infraestructura",
    "Secretaría de la Mujer",
    "Secretaría de Salud",
    "Secretaría General",
];


const colores = {
    Emcaservicios: "#03a9f4",
    Indeportes: "#fb4f19",
    "Oficina Asesora de Gestión del Riesgo": "#ffc107",
    "Oficina Asesora de Planeación": "#2b3960",
    "Oficina Asesora Jurídica": "#795548",
    "Oficina de Gestión Social y Asuntos Poblacionales": "#6c757d",
    "Secretaría de Agricultura y Desarrollo Rural": "#28a745",
    "Secretaría de Desarrollo Económico y Competitividad": "#052c65",
    "Secretaría de Educación y Cultura": "#dc3545",
    "Secretaría de Gobierno y Participación": "#58151c",
    "Secretaría de Hacienda": "#8a2be2",
    "Secretaría de Infraestructura": "#6c757d",
    "Secretaría de la Mujer": "#ed8194",
    "Secretaría de Salud": "#0d6efd",
    "Secretaría General": "#0a3622",
};

const logos = {
    Indeportes: Indeportes,
    "Oficina Asesora de Gestión del Riesgo": UNGRD,
    Emcaservicios: emcaservicios,
};

const subregiones = [
    { nombre: "Norte", icono: Norte, color: "#f9c611" },
    { nombre: "Costa Pacífica", icono: Occidente, color: "#e86b0f" },
    { nombre: "Oriente", icono: Oriente, color: "#a2c315" },
    { nombre: "Centro", icono: Centro, color: "#2086c8" },
    { nombre: "Sur", icono: Sur, color: "#f79c00" },
    { nombre: "Macizo", icono: Cauca, color: "#398433" },
    { nombre: "Amazónico", icono: Occidente, color: "#4ba833" },
];


const municipios = [
    "Almaguer", "Argelia", "Balboa", "Bolívar", "Buenos Aires", "Cajibío", "Caldono",
    "Caloto", "Corinto", "El Tambo", "Florencia", "Guachene", "Guapi", "Inzá",
    "Jambaló", "La Sierra", "La Vega", "López de Micay", "Mercaderes", "Miranda", "Morales",
    "Padilla", "Patía", "Piamonte", "Piendamó - Tunía", "Popayán", "Puerto Tejada",
    "Páez", "Purace", "Rosas", "San Sebastian", "Santa Rosa", "Santander De Quilichao",
    "Silvia", "Sotara", "Suárez", "Sucre", "Timbio", "Timbiquí", "Toribío", "Totoro",
    "Villa Rica"
];


const municipiosSubregiones = [
    {
        nombre: "Norte",
        icono: Norte,
        color: "#f9c611",
        municipios: [
            "Buenos Aires", "Caloto", "Corinto", "Guachene", "Miranda",
            "Padilla", "Puerto Tejada", "Santander De Quilichao", "Villa Rica"
        ]
    },
    {
        nombre: "Costa Pacífica",
        icono: Occidente,
        color: "#e86b0f",
        municipios: ["Guapi", "Lopez", "Timbiquí"]
    },
    {
        nombre: "Oriente",
        icono: Oriente,
        color: "#a2c315",
        municipios: ["Caldono", "Inzá", "Jambaló", "Páez", "Purace", "Silvia", "Toribío", "Totoro"]
    },
    {
        nombre: "Centro",
        icono: Centro,
        color: "#2086c8",
        municipios: ["Cajibío", "El Tambo", "Piendamó - Tunía", "Popayán", "Rosas", "Timbio", "Sotara"]
    },
    {
        nombre: "Sur",
        icono: Sur,
        color: "#f79c00",
        municipios: ["Balboa", "Bolívar", "La Sierra", "La Vega", "Mercaderes", "San Sebastian", "Santa Rosa", "Sucre"]
    },
    {
        nombre: "Macizo",
        icono: Cauca,
        color: "#398433",
        municipios: ["Almaguer", "Argelia", "Florencia", "Patía"]
    },
    {
        nombre: "Amazónico",
        icono: Occidente,
        color: "#4ba833",
        municipios: ["Piamonte"]
    }
];

const MapaCauca = () => {
    const [expandirEntidades, setExpandirEntidades] = useState(false); // Estado para entidades
    const [expandirSubregiones, setExpandirSubregiones] = useState(false); // Estado para subregiones
    const [expandirMunicipios, setExpandirMunicipios] = useState(false); // Estado para controlar la expansión de la lista

    const [filtroMunicipios, setFiltroMunicipios] = useState(""); // Filtro para municipios
    const [filtroEntidades, setFiltroEntidades] = useState(""); // Filtro para dependencias
    const [filtroSubregiones, setFiltroSubregiones] = useState(""); // Filtro para subregiones

    const [panelContraido, setPanelContraido] = useState(false);
    const togglePanel = () => setPanelContraido(!panelContraido);

    const [menuVisible, setMenuVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [selectedMunicipio, setSelectedMunicipio] = React.useState(null);
    const [mapKey, setMapKey] = useState(0);
    const [municipioSeleccionadopadre, setMunicipioSeleccionadopadre] = useState(null);


    const [dataInicial, setDataInicial] = useState([]); // Copia original
    const [proyectos, setProyectos] = useState([]); // Datos visibles
    const [filteredData, setFilteredData] = useState([]); // Datos filtrados
    const [filtroActivo, setFiltroActivo] = useState(null); // Tipo de filtro activo
    const [isActive, setIsActive] = useState(false); // Estado del botón


    const [mostrarBody, setMostrarBody] = useState(true);
    const [mostrarBodyO, setMostrarBodyO] = useState(true);


    //Llamado al Servicio
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProyectos = async () => {
            try {
                const data = await dataMapaService.getProyectos();
                const proyectosData = data.data;

                setProyectos(proyectosData); // Actualiza el estado con los datos
                setDataInicial([...proyectosData]);
                setFilteredData([...proyectosData]);

                // Procesa las estadísticas
                calcularEstadisticas(proyectosData);

            } catch (err) {
                setError('Error al cargar los proyectos');
            }
        };

        fetchProyectos();
    }, []);


    useEffect(() => {
        setFilteredData([...proyectos]); // Sincroniza los datos visibles con los filtrados
    }, [proyectos]);

    const toggleFiltro = (origen) => {
        // Si el filtro actual ya está activo y coincide con el seleccionado, restaurar todos los proyectos
        if (isActive && origen === filtroActivo) {
            limpiarFiltros();
            return; // Salir de la función
        }

        // Aplicar filtro seleccionado
        let filtered = [];

        if (Array.isArray(dataInicial)) {
            if (origen === 1) {
                // Proyectos nuevos
                filtered = dataInicial.filter((proyecto) => proyecto.vigenciaInicial >= 2024);
            } else if (origen === 2) {
                // Vigencias anteriores
                filtered = dataInicial.filter((proyecto) => proyecto.vigenciaInicial < 2024);
            } else {
                // Todos los proyectos
                filtered = [...dataInicial];
            }
        } else {
            console.error('Error: "dataInicial" no es un array:', dataInicial);
        }

        // Actualizar proyectos y estadísticas
        setProyectos(filtered);
        calcularEstadisticas(filtered);

        // Activar el filtro
        setIsActive(true);
        setFiltroActivo(origen); // Guardar el filtro activo
    };

    const handleShow = (origen) => {
        let filtered;

        if (origen === 1) {
            // Caso 1: Filtrar proyectos nuevos
            filtered = proyectos.filter((proyecto) => proyecto.vigenciaInicial >= 2024);
        } else if (origen === 2) {
            // Caso 2: Filtrar proyectos de otras vigencias
            filtered = proyectos.filter((proyecto) => proyecto.vigenciaInicial < 2024);
        }
        else if (origen === 4) {
            // Caso 4: Filtrar proyectos de cauca
            filtered = proyectos.filter((proyecto) =>
                proyecto.municipios.some(
                    (municipio) => municipio.codMpio === "19000" && municipio.nomMunicipio.toLowerCase() === "cauca"
                )
            );

        }
        else {
            // Caso 3: Mostrar todos los proyectos
            filtered = proyectos;
        }

        // Guardar los datos filtrados
        setFilteredData(filtered);
        // Mostrar el modal
        setShowModal(true);
    };


    const handleClose = () => {
        setShowModal(false); // Cierra el modal
    };


    const [showModalG, setShowModalG] = useState(false);


    const handleShowG = () => setShowModalG(true);
    const handleCloseG = () => setShowModalG(false);


    // Función para mostrar el modal
    const handleShowI = () => {
        setIsModalVisible(true);
    };

    // Función para cerrar el modal
    const handleCloseI = () => {
        setIsModalVisible(false);
    };


    const [visible, setVisible] = useState(false); // Estado para controlar la visibilidad

    const toggleVisibility = () => {
        setVisible(!visible); // Cambia el estado entre visible e invisible
    };


    // Generar colores predeterminados (puedes personalizarlos o asignarlos por municipio si es necesario)
    const generarColor = (index) => {
        const coloresBase = [
            "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3",
            "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39",
            "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
        ];
        return coloresBase[index % coloresBase.length];
    };

    const municipiosFiltrados = municipios.filter((municipio) =>
        municipio.toLowerCase().includes(filtroMunicipios.toLowerCase())
    );

    const entidadesFiltradas = entidades.filter((entidad) =>
        entidad.toLowerCase().includes(filtroEntidades.toLowerCase())
    );

    const subregionesFiltradas = subregiones.filter((subregion) =>
        subregion.nombre.toLowerCase().includes(filtroSubregiones.toLowerCase())
    );


    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
        setPanelContraido(false);
    };

    const [estadisticas, setEstadisticas] = useState({
        totalProyectos: 0,
        proyectosNuevos: 0,
        otrasVigencias: 0,
        inversionTotal: 0,
        inversionProyectosNuevos: 0,
        inversionOtrasVigencias: 0,
        proyectosRegion: 0,
        nuevosSinApropiacion: 0,
        nuevosConApropiacion: 0,
        nuevosEnEjecucion: 0,
        nuevosSinEjecucion: 0, // Nueva variable
        otrasSinApropiacion: 0,
        otrasConApropiacion: 0,
        otrasEnEjecucion: 0,
        otrasSinEjecucion: 0, // Nueva variable
    });



    const limpiarFiltros = () => {
        setFiltroMunicipios(""); // Limpia el filtro de municipios
        setFiltroEntidades(""); // Limpia el filtro de dependencias
        setFiltroSubregiones(""); // Limpia el filtro de subregiones
        setFiltroActivo(false);
        setIsActive(false);
        setProyectos([...dataInicial]); // Restaura todos los proyectos
        calcularEstadisticas(dataInicial); // Recalcula estadísticas con los datos originales

        setMapKey((prevKey) => prevKey + 1);
        setMunicipioSeleccionadopadre(null);

    };

    const renderPanel1 = () => {
        return (
            <div
                style={{
                    flex: "1", // Asegura que el contenido ocupe todo el espacio disponible
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Botón de contraer/expandir */}
                <div className="d-flex justify-content-end d-none d-md-block">
                    <button
                        className={`btn btn-${panelContraido ? "primary" : "secondary"} d-flex align-items-center justify-content-center`}
                        onClick={togglePanel}

                        style={{
                            position: "sticky",
                            top: 10, // Espacio desde la parte superior
                            zIndex: 1000,
                            padding: "10px 15px", // Espaciado interno
                            borderRadius: "20px", // Bordes redondeados
                            fontWeight: "bold", // Texto en negrita
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Sombra para destacar
                            transition: "all 0.3s ease", // Transición suave en cambios
                        }}
                    >
                        {panelContraido ? (
                            <>
                                <i className="bi bi-chevron-right me-2" style={{ fontSize: "16px" }}></i>
                                <span>Extender</span>
                            </>
                        ) : (
                            <>
                                <i className="bi bi-chevron-left me-2" style={{ fontSize: "16px" }}></i>
                                <span>Contraer</span>
                            </>
                        )}
                    </button>
                </div>

                {/* Municipios */}
                <div
                    className={`bg-white p-3 rounded shadow-sm mb-3 ${panelContraido ? "d-flex flex-column align-items-center" : ""}`}
                >
                    {panelContraido ? (
                        <div className="d-flex flex-column align-items-center">
                            {municipiosFiltrados
                                .slice(0, expandirMunicipios ? municipiosFiltrados.length : 4)
                                .map((municipio, index) => (
                                    <div
                                        key={index}
                                        className="circle-logo mb-2 d-flex justify-content-center align-items-center"
                                        style={{
                                            backgroundColor: generarColor(index),
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            border: filtroMunicipios === municipio ? "2px solid #198754" : "none", // Resaltar si está activo
                                        }}
                                        onClick={() => {
                                            if (filtroMunicipios === municipio) {
                                                // Si el filtro ya está aplicado, restaurar los datos originales
                                                setFiltroMunicipios("");
                                                setProyectos([...dataInicial]); // Restaurar todos los proyectos
                                                calcularEstadisticas(dataInicial); // Recalcular estadísticas
                                                setMapKey((prevKey) => prevKey + 1);
                                                setMunicipioSeleccionadopadre(null);
                                            } else {
                                                // Aplicar el filtro por municipio
                                                filtrarPorMunicipio(municipio);
                                                setMunicipioSeleccionadopadre(municipio);
                                            }

                                        }}
                                    >
                                        <Tooltip
                                            title={municipio} // Muestra el nombre completo del municipio
                                            placement="top" // Ubicación del tooltip
                                        >
                                            <span
                                                style={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                {municipio.substring(0, 2).toUpperCase()}
                                            </span>
                                        </Tooltip>
                                    </div>
                                ))}
                        </div>
                    ) : (
                        <>
                            <div className="mb-3">
                                <div className="mb-3 position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="¿Buscar municipio?"
                                        value={filtroMunicipios}
                                        onChange={(e) => setFiltroMunicipios(e.target.value)}
                                    />
                                    {filtroMunicipios && (
                                        <button
                                            type="button"
                                            className="position-absolute top-50 end-0 translate-middle-y me-2"
                                            aria-label="Clear"
                                            onClick={() => {
                                                setFiltroMunicipios(""); // Limpia el filtro del input
                                                setProyectos([...dataInicial]); // Restaura todos los proyectos
                                                calcularEstadisticas(dataInicial); // Recalcula estadísticas
                                                setMapKey((prevKey) => prevKey + 1);
                                                setMunicipioSeleccionadopadre(null);

                                            }}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                color: "#6c757d", // Color de la "X"
                                                fontSize: "1.5rem",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                lineHeight: "1",
                                            }}
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="list-group">
                                {municipiosFiltrados
                                    .slice(0, expandirMunicipios ? municipiosFiltrados.length : 4)
                                    .map((municipio, index) => (
                                        <button
                                            key={index}
                                            className="list-group-item list-group-item-action d-flex align-items-center"
                                            onClick={() => {
                                                filtrarPorMunicipio(municipio); // Filtrar datos
                                                setMunicipioSeleccionadopadre(municipio); // Enviar el nombre al hijo
                                                toggleMenu();
                                            }}
                                        >
                                            <div
                                                className="circle-logo me-3 d-flex justify-content-center align-items-center"
                                                style={{
                                                    backgroundColor: generarColor(index),
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    color: "#fff",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    cursor: "pointer",
                                                }}
                                                title={municipio}
                                            >
                                                {municipio.substring(0, 2).toUpperCase()}
                                            </div>
                                            {municipio}
                                        </button>
                                    ))}
                            </div>
                        </>
                    )}

                    {/* Mostrar el botón solo si no hay un filtro activo */}
                    {!filtroMunicipios && (
                        <button
                            className="btn btn-outline-primary w-100 mt-2"
                            onClick={() => setExpandirMunicipios(!expandirMunicipios)}
                        >
                            {expandirMunicipios ? (
                                <>
                                    <span>Mostrar menos </span>
                                    <i className="bi bi-chevron-double-up"></i>
                                </>
                            ) : (
                                <>
                                    <span>Mostrar más</span>
                                    <i className="bi bi-chevron-double-down"></i>
                                </>
                            )}
                        </button>
                    )}
                </div>

                {/* Subregiones */}
                <div
                    className={`bg-white p-3 rounded shadow-sm mb-3 ${panelContraido ? "d-flex flex-column align-items-center" : ""
                        }`}
                >
                    {panelContraido ? (
                        <div className="d-flex flex-column align-items-center">
                            {subregionesFiltradas
                                .slice(0, expandirSubregiones ? subregionesFiltradas.length : 4)
                                .map((subregion, index) => (
                                    <Tooltip
                                        key={index}
                                        title={subregion.nombre} // Muestra el nombre completo de la subregión
                                        placement="top" // Ubicación del tooltip
                                    >
                                        <div
                                            className="circle-logo mb-2 d-flex justify-content-center align-items-center"
                                            style={{
                                                backgroundColor: subregion.color,
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "50%",
                                                cursor: "pointer",
                                                border:
                                                    filtroSubregiones === subregion.nombre
                                                        ? "2px solid #198754"
                                                        : "none", // Resaltar si está activo
                                            }}
                                            onClick={() => {
                                                if (filtroSubregiones === subregion.nombre) {
                                                    // Restaurar los datos originales
                                                    setFiltroSubregiones("");
                                                    setProyectos([...dataInicial]); // Restaurar todos los proyectos
                                                    calcularEstadisticas(dataInicial); // Recalcular estadísticas
                                                } else {
                                                    // Aplicar el filtro por subregión
                                                    filtrarPorSubregion(subregion.nombre);
                                                }
                                            }}
                                        >
                                            <img
                                                src={subregion.icono}
                                                alt={subregion.nombre}
                                                style={{
                                                    width: "70%",
                                                    height: "70%",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    </Tooltip>
                                ))}
                            {!filtroSubregiones && (
                                <button
                                    className="btn btn-outline-primary w-100 mt-2"
                                    onClick={() => setExpandirSubregiones(!expandirSubregiones)}
                                >
                                    {expandirSubregiones ? (
                                        <>
                                            <span>Mostrar menos</span>
                                            <i className="bi bi-chevron-double-up"></i>
                                        </>
                                    ) : (
                                        <>
                                            <span>Mostrar más</span>
                                            <i className="bi bi-chevron-double-down"></i>
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    ) : (
                        <>
                            <div className="mb-3">
                                <div className="mb-3 position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="¿Buscar por Subregión?"
                                        value={filtroSubregiones}
                                        onChange={(e) => setFiltroSubregiones(e.target.value)}
                                    />
                                    {filtroSubregiones && (
                                        <button
                                            type="button"
                                            className="position-absolute top-50 end-0 translate-middle-y me-2"
                                            aria-label="Clear"
                                            onClick={() => {
                                                setFiltroSubregiones(""); // Limpia el filtro
                                                setProyectos([...dataInicial]); // Restaura todos los proyectos
                                                calcularEstadisticas(dataInicial); // Recalcula estadísticas
                                            }}
                                            style={{
                                                background: "transparent",
                                                border: "none",
                                                color: "#6c757d",
                                                fontSize: "1.5rem",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                lineHeight: "1",
                                            }}
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="list-group">
                                {subregionesFiltradas
                                    .slice(0, expandirSubregiones ? subregionesFiltradas.length : 4)
                                    .map((subregion, index) => (
                                        <button
                                            key={index}
                                            className="list-group-item list-group-item-action d-flex align-items-center"
                                            onClick={() => {
                                                if (filtroSubregiones === subregion.nombre) {
                                                    setFiltroSubregiones("");
                                                    setProyectos([...dataInicial]); // Restaurar todos los proyectos
                                                    calcularEstadisticas(dataInicial); // Recalcular estadísticas
                                                } else {
                                                    filtrarPorSubregion(subregion.nombre);
                                                    toggleMenu();
                                                }
                                            }}
                                        >
                                            <div
                                                className="circle-logo me-3 d-flex justify-content-center align-items-center"
                                                style={{
                                                    backgroundColor: subregion.color,
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "50%",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <img
                                                    src={subregion.icono}
                                                    alt={subregion.nombre}
                                                    style={{
                                                        width: "70%",
                                                        height: "70%",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                            </div>
                                            {subregion.nombre}
                                        </button>
                                    ))}
                            </div>

                            {!filtroSubregiones && (
                                <button
                                    className="btn btn-outline-primary w-100 mt-2"
                                    onClick={() => setExpandirSubregiones(!expandirSubregiones)}
                                >
                                    {expandirSubregiones ? (
                                        <>
                                            <span>Mostrar menos</span>
                                            <i className="bi bi-chevron-double-up"></i>
                                        </>
                                    ) : (
                                        <>
                                            <span>Mostrar más</span>
                                            <i className="bi bi-chevron-double-down"></i>
                                        </>
                                    )}
                                </button>
                            )}
                        </>
                    )}
                </div>



                {/* Dependencias */}
                <div className={`bg-white p-3 rounded shadow-sm mb-3 ${panelContraido ? "d-flex flex-column align-items-center" : ""}`}>
                    {panelContraido ? (
                        <div className="d-flex flex-column align-items-center">
                            {entidadesFiltradas
                                .slice(0, expandirEntidades ? entidadesFiltradas.length : 4)
                                .map((entidad, index) => (
                                    <Tooltip
                                        key={index}
                                        title={entidad} // Muestra el nombre completo de la entidad
                                        placement="top" // Ubicación del tooltip
                                    >
                                        <div
                                            className="circle-logo mb-2 d-flex justify-content-center align-items-center"
                                            style={{
                                                backgroundColor: colores[entidad] || "#cccccc",
                                                width: "50px", // Tamaño fijo del círculo
                                                height: "50px", // Tamaño fijo del círculo
                                                borderRadius: "50%",
                                                flexShrink: 0, // Evita deformaciones en el contenedor
                                                cursor: "pointer",
                                                border: filtroEntidades === entidad ? "2px solid #198754" : "none", // Resaltar si está activo
                                            }}
                                            onClick={() => {
                                                if (filtroEntidades === entidad) {
                                                    // Si el filtro ya está aplicado, restaurar los datos originales
                                                    setFiltroEntidades("");
                                                    setProyectos([...dataInicial]); // Restaurar todos los proyectos
                                                    calcularEstadisticas(dataInicial); // Recalcular estadísticas
                                                } else {
                                                    // Aplicar el filtro por dependencia
                                                    filtrarPorEntidad(entidad);

                                                }
                                            }}
                                        >
                                            <img
                                                src={logos[entidad] || logogobernacion}
                                                alt={entidad}
                                                style={{
                                                    width: "80%", // Tamaño uniforme dentro del círculo
                                                    height: "80%",
                                                    objectFit: "contain", // Asegura que no se deforme la imagen
                                                }}
                                            />
                                        </div>
                                    </Tooltip>
                                ))}
                        </div>
                    ) : (
                        <>
                            <div className="mb-3 position-relative">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="¿Buscar dependencia?"
                                    value={filtroEntidades}
                                    onChange={(e) => setFiltroEntidades(e.target.value)}
                                />
                                {filtroEntidades && (
                                    <button
                                        type="button"
                                        className="position-absolute top-50 end-0 translate-middle-y me-2"
                                        aria-label="Clear"
                                        onClick={() => {
                                            setFiltroEntidades(""); // Limpia el filtro
                                            setProyectos([...dataInicial]); // Restaura todos los proyectos
                                            calcularEstadisticas(dataInicial); // Recalcula estadísticas
                                        }}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            color: "#6c757d", // Color de la "X"
                                            fontSize: "1.5rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            lineHeight: "1",
                                        }}
                                    >
                                        &times;
                                    </button>
                                )}
                            </div>

                            <div className="list-group">
                                {entidadesFiltradas
                                    .slice(0, expandirEntidades ? entidadesFiltradas.length : 4)
                                    .map((entidad, index) => (
                                        <Tooltip
                                            key={index}
                                            title={entidad} // Muestra el nombre completo de la entidad
                                            placement="top" // Ubicación del tooltip
                                        >
                                            <button
                                                className="list-group-item list-group-item-action d-flex align-items-center"
                                                onClick={() => {
                                                    if (filtroEntidades === entidad) {
                                                        // Si el filtro ya está aplicado, restaurar los datos originales
                                                        setFiltroEntidades("");
                                                        setProyectos([...dataInicial]); // Restaurar todos los proyectos
                                                        calcularEstadisticas(dataInicial); // Recalcular estadísticas
                                                    } else {
                                                        // Aplicar el filtro por dependencia
                                                        filtrarPorEntidad(entidad);
                                                        toggleMenu();

                                                    }
                                                }}
                                            >
                                                <div
                                                    className="circle-logo me-3 d-flex justify-content-center align-items-center"
                                                    style={{
                                                        backgroundColor: colores[entidad] || "#cccccc",
                                                        width: "50px", // Tamaño fijo del círculo
                                                        height: "50px", // Tamaño fijo del círculo
                                                        borderRadius: "50%",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <img
                                                        src={logos[entidad] || logogobernacion}
                                                        alt={entidad}
                                                        style={{
                                                            width: "80%", // Tamaño uniforme dentro del círculo
                                                            height: "80%",
                                                            objectFit: "contain", // Asegura que no se deforme la imagen
                                                        }}
                                                    />
                                                </div>
                                                {entidad}
                                            </button>
                                        </Tooltip>
                                    ))}

                            </div>
                        </>
                    )}

                    {/* Mostrar el botón solo si no hay un filtro activo */}
                    {!filtroEntidades && (
                        <button
                            className="btn btn-outline-primary w-100 mt-2"
                            onClick={() => setExpandirEntidades(!expandirEntidades)}
                        >
                            {expandirEntidades ? (
                                <>
                                    <span>Mostrar menos </span>
                                    <i className="bi bi-chevron-double-up"></i>
                                </>
                            ) : (
                                <>
                                    <span>Mostrar más</span>
                                    <i className="bi bi-chevron-double-down"></i>
                                </>
                            )}
                        </button>
                    )}
                </div>




            </div >
        )
    }


    const renderResumenProyectos = () => {
        return (
            <div>
                <Title level={3} style={{ textAlign: 'center', marginBottom: '20px' }}>
                    Resumen de proyectos de inversión
                </Title>
                <List
                    bordered
                    dataSource={[
                        {
                            label: 'Total proyectos',
                            value: estadisticas.totalProyectos,
                            color: 'green',
                        },
                        {
                            label: 'Proyectos Nuevos',
                            value: estadisticas.proyectosNuevos,
                            color: 'green',
                        },
                        {
                            label: 'Otras vigencias',
                            value: estadisticas.otrasVigencias,
                            color: 'green',
                        },
                        {
                            label: 'Inversión total',
                            value: `$ ${Math.round(estadisticas.inversionTotal).toLocaleString()}`,
                            color: 'purple',
                        },
                        {
                            label: 'Inversión proyectos nuevos',
                            value: `$ ${Math.round(estadisticas.inversionProyectosNuevos).toLocaleString()}`,
                            color: 'purple',
                        },
                        {
                            label: 'Inversión otras vigencias',
                            value: `$ ${Math.round(estadisticas.inversionOtrasVigencias).toLocaleString()}`,
                            color: 'purple',
                        },
                    ]}
                    renderItem={(item) => (
                        <List.Item>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center', // Alinea verticalmente los elementos
                                    width: '100%',
                                }}
                            >
                                <span
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        color: '#333',
                                    }}
                                >
                                    {item.label}:
                                </span>
                                <span
                                    style={{
                                        backgroundColor: item.color,
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        fontSize: '14px',
                                        whiteSpace: 'nowrap', // Evita que el texto se divida en varias líneas
                                        textAlign: 'center', // Centra el texto dentro del span
                                        minWidth: '50px', // Asegura un tamaño mínimo
                                    }}
                                >
                                    {item.value}
                                </span>
                            </div>
                        </List.Item>
                    )}
                />
            </div>
        );
    };



    const calcularEstadisticas = (data) => {
        // Total de proyectos (basado en valores únicos de 'radicado')
        const totalProyectos = new Set(data.map((proyectos) => proyectos.radicado)).size;

        // Proyectos nuevos y otras vigencias
        let proyectosNuevos = 0;
        let otrasVigencias = 0;

        // Inversión total
        let inversionTotal = 0;

        // Inversión proyectos nuevos y otras vigencias
        let inversionProyectosNuevos = 0;
        let inversionOtrasVigencias = 0;

        // Proyectos de región
        let proyectosRegion = 0;

        // Variables para clasificar proyectos
        let nuevosSinApropiacion = 0;
        let nuevosConApropiacion = 0;
        let nuevosEnEjecucion = 0;
        let nuevosSinEjecucion = 0; // Nueva variable

        let otrasSinApropiacion = 0;
        let otrasConApropiacion = 0;
        let otrasEnEjecucion = 0;
        let otrasSinEjecucion = 0; // Nueva variable

        data.forEach((proyectos) => {
            const {
                vigenciaInicial,
                total,
                municipios,
                apropiacionVigente,
                certificadoVigente,
                comprometidoVigente,
            } = proyectos;

            // Suma al total de inversión
            inversionTotal += total;

            // Clasifica proyectos por vigencia
            if (vigenciaInicial >= 2024) {
                proyectosNuevos++;
                inversionProyectosNuevos += total;

                // Clasificación por estado
                if ((apropiacionVigente ?? 0) === 0) {
                    nuevosSinApropiacion++;
                }

                if ((apropiacionVigente ?? 0) > 0) {

                    if ((comprometidoVigente ?? 0) === 0) {
                        nuevosConApropiacion++;
                    }
                    if ((comprometidoVigente ?? 0) > 0) {
                        nuevosEnEjecucion++;
                    }

                }

                // Proyectos sin ejecución Verificar calculo
                if ((apropiacionVigente ?? 0) >= 0 && (comprometidoVigente ?? 0) <= 0) {
                    nuevosSinEjecucion++;
                }
            }
            else {
                otrasVigencias++;
                inversionOtrasVigencias += total;

                // Clasificación por estado
                if ((apropiacionVigente ?? 0) === 0) {
                    otrasSinApropiacion++;
                }

                if ((apropiacionVigente ?? 0) > 0) {
                    if ((comprometidoVigente ?? 0) === 0) {
                        otrasConApropiacion++;
                    }
                    if ((comprometidoVigente ?? 0) > 0) {
                        otrasEnEjecucion++;
                    }
                }

                // Proyectos sin ejecución
                if ((apropiacionVigente ?? 0) >= 0 && (comprometidoVigente ?? 0) <= 0) {
                    otrasSinEjecucion++;
                }
            }


            // Contar proyectos de región
            if (
                municipios.length === 1 &&
                municipios[0].codMpio === "19000" &&
                municipios[0].nomMunicipio === "Cauca"
            ) {
                proyectosRegion++;
            }
        });

        // Actualiza las estadísticas
        setEstadisticas({
            totalProyectos,
            proyectosNuevos,
            otrasVigencias,
            inversionTotal,
            inversionProyectosNuevos,
            inversionOtrasVigencias,
            proyectosRegion,
            nuevosSinApropiacion,
            nuevosConApropiacion,
            nuevosEnEjecucion,
            nuevosSinEjecucion, // Nueva variable
            otrasSinApropiacion,
            otrasConApropiacion,
            otrasEnEjecucion,
            otrasSinEjecucion, // Nueva variable
        });
    };



    const filtrarPorMunicipio = (municipio) => {


        if (!municipio) {
            // Restaurar todos los proyectos si no hay filtro
            setProyectos([...dataInicial]); // Restaurar todos los proyectos
            calcularEstadisticas(dataInicial); // Recalcular estadísticas con los datos originales
            setFiltroMunicipios(""); // Limpiar el filtro del input
            setMapKey((prevKey) => prevKey + 1);
            setMunicipioSeleccionadopadre(null);

        } else {
            // Filtrar los proyectos por municipio
            const filtrados = dataInicial.filter((proyecto) =>
                proyecto.municipios.some(
                    (mun) => mun.nomMunicipio.toLowerCase() === municipio.toLowerCase()
                )
            );

            // Actualizar proyectos y estadísticas
            setProyectos(filtrados);
            calcularEstadisticas(filtrados);

            // Establecer el filtro en el input
            setFiltroMunicipios(municipio);
            // Desactivar otros filtros
            setFiltroEntidades("");
            setFiltroSubregiones("");

        }
    };

    const filtrarPorSubregion = (region) => {
        if (!region) {
            // Restaurar todos los proyectos si no hay filtro
            setProyectos([...dataInicial]); // Restaurar todos los proyectos
            calcularEstadisticas(dataInicial); // Recalcular estadísticas con los datos originales
            setFiltroSubregiones(""); // Limpiar el filtro del input
        } else {

            // Desactivar otros filtros
            setFiltroMunicipios("");
            setFiltroEntidades("");

            // Encuentra los municipios asociados a la subregión seleccionada
            const subregionSeleccionada = municipiosSubregiones.find(
                (subregion) => subregion.nombre.toLowerCase() === region.toLowerCase()
            );

            if (subregionSeleccionada) {
                const municipiosDeLaSubregion = subregionSeleccionada.municipios;

                // Filtrar los proyectos por municipios que pertenecen a la subregión
                const filtrados = dataInicial.filter((proyecto) =>
                    proyecto.municipios.some((mun) =>
                        municipiosDeLaSubregion.includes(mun.nomMunicipio)
                    )
                );

                // Actualizar proyectos y estadísticas
                setProyectos(filtrados);
                calcularEstadisticas(filtrados);

                // Establecer el filtro en el input
                setFiltroSubregiones(region);
            } else {
                // Si no se encuentra la subregión, limpiar el filtro
                setProyectos([...dataInicial]);
                calcularEstadisticas(dataInicial);
                setFiltroSubregiones("");
            }
        }
    };

    const filtrarPorEntidad = (entidad) => {
        if (!entidad) {
            // Restaurar todos los proyectos si no hay filtro
            setProyectos([...dataInicial]); // Restaurar todos los proyectos
            calcularEstadisticas(dataInicial); // Recalcular estadísticas con los datos originales
            setFiltroEntidades(""); // Limpiar el filtro del input
        } else {

            // Desactivar otros filtros
            setFiltroMunicipios("");
            setFiltroSubregiones("");
            // Filtrar los proyectos por dependencia
            const filtrados = dataInicial.filter((proyecto) =>
                proyecto.dependencia.toLowerCase() === entidad.toLowerCase()
            );

            // Actualizar proyectos y estadísticas
            setProyectos(filtrados);
            calcularEstadisticas(filtrados);

            // Establecer el filtro en el input
            setFiltroEntidades(entidad);
        }
    };


    const handleMunicipioClick = (id) => {
        setSelectedMunicipio(id);

        if (id === 'Cauca') {
            limpiarFiltros();
        } else {
            filtrarPorMunicipio(id)
        }

    };



    return (

        <>
            <div className="container">
                {/* Botón para abrir el menú (solo visible en móvil) */}
                <button
                    className="btn btn-primary d-md-none"
                    onClick={toggleMenu}
                    style={{
                        position: "fixed",
                        top: "10px",
                        right: "10px",
                        zIndex: 1050,
                    }}
                >
                    <i className="bi bi-list" style={{ fontSize: "24px" }}></i>
                </button>

                {/* Menú Offcanvas */}

                <div
                    className={`offcanvas-panel ${menuVisible ? "visible" : ""}`}
                    style={{
                        position: "fixed",
                        top: 0,
                        right: 0,
                        width: "80%",
                        height: "100vh",
                        backgroundColor: "#f8f9fa",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        zIndex: 1040,
                        transform: menuVisible ? "translateX(0)" : "translateX(100%)",
                        transition: "transform 0.3s ease-in-out",
                        overflowY: "auto",
                    }}
                >
                    <div className="p-3 d-md-none"> {/* Solo visible en versión móvil */}

                        <h4>Filtros</h4>

                        {/* Aquí reutilizamos el contenido del Panel 1 */}
                        {renderPanel1()}
                    </div>
                </div>
            </div>



            <div className="container-fluid">
                {/* Encabezado */}
                <div className="row align-items-center">
                    {/* Logos */}
                    <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
                        <div className="text-center me-2">
                            <img
                                src={logo1}
                                alt="Gobernación del Cauca"
                                className="img-fluid logo-adjusted"
                            />
                        </div>
                        <div className="text-center">
                            <img
                                src={logo2}
                                alt="Sistema de Información Socioeconómica del Cauca"
                                className="img-fluid logo-adjusted"
                            />
                        </div>
                    </div>

                    {/* Título y botón */}
                    <div className="col-12 col-md-8 d-flex flex-column flex-md-row justify-content-end align-items-center">
                        <h1 className="fw-bold text-primary mb-2 mb-md-0 text-center text-md-start me-md-3">
                            Mapa de Inversiones
                        </h1>
                        <div className="d-flex flex-wrap justify-content-center">
                            <Button
                                type="default"
                                icon={<DeleteOutlined />}
                                onClick={() => limpiarFiltros()}
                                className="hover-button me-2 mb-2"
                            >
                                Limpiar filtros
                            </Button>
                            <Button
                                type="default"
                                icon={<QuestionCircleOutlined />}
                                onClick={handleShowI}
                                className="hover-button mb-2"
                                style={{ backgroundColor: '#198754', color: '#FFF' }}
                            >
                                Indicaciones
                            </Button>
                        </div>
                    </div>
                </div>





                {/* Contenido principal */}
                <div className="row mt-4">
                    {/* Panel izquierdo */}

                    <div
                        className={`transition ${panelContraido ? "col-md-1" : "col-md-3"} col-12 order-3 order-md-1 d-none d-md-block`} // Solo visible en versión web
                        style={{
                            overflowY: "auto", // Habilita el scroll vertical
                            height: "calc(100vh - 100px)", // Ajusta la altura al viewport menos un margen opcional (como encabezados o pies de página)
                            display: "flex",
                            flexDirection: "column",
                            position: "sticky", // Mantén el panel fijo al desplazarte
                            top: "0", // Fija la posición superior
                        }}
                    >
                        {renderPanel1()}
                    </div>


                    {/* Panel Central */}
                    <div className={`transition ${panelContraido ? "col-md-8" : "col-md-6"} col-12 order-1 order-md-2`}>
                        <div className="bg-light p-3 rounded shadow-sm">
                            <div><strong>Fuente: Banco de proyectos - Grupo inversión y finanzas públicas - Gobernación del Cauca</strong></div>
                            <div className="map-placeholder" style={{ height: "600px" }}>

                                <MapaCaucaDepartamento
                                    key={mapKey}
                                    data={proyectos}
                                    onMunicipioClick={handleMunicipioClick} // Notificar al padre cuando se selecciona en el mapa
                                    municipioSeleccionadopadre={municipioSeleccionadopadre} // Enviar el municipio seleccionado al mapa
                                />

                            </div>
                        </div>
                    </div>

                    {/* Panel derecho */}
                    <div
                        className="col-md-3 col-12 order-2 order-md-3"
                        style={{
                            overflowY: "auto", // Habilita el desplazamiento vertical
                            height: "calc(100vh - 100px)", // Ajusta la altura al viewport menos un margen (encabezado o pie)
                            display: "flex", // Configura el contenedor como flexbox
                            flexDirection: "column", // Alinea elementos verticalmente
                            position: "sticky", // Fija el panel al desplazarte
                            top: "0", // Establece el punto de anclaje en la parte superior
                        }}
                    >

                        {(filtroMunicipios || filtroSubregiones || filtroEntidades) && (
                            <div className="card p-3 rounded shadow-sm mb-3" style={{ background: '#f3f3f3' }}>
                                <p
                                    className="fs-4 fw-bold m-0"
                                    style={{
                                        color: '#2c3960',
                                        textAlign: 'center',
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06)',
                                        padding: '10px 20px',
                                        backgroundColor: '#f9f9f9',
                                        borderRadius: '8px',
                                        display: 'inline-block',
                                    }}
                                >
                                    {filtroMunicipios || filtroSubregiones || filtroEntidades}
                                </p>
                            </div>
                        )}


                        <div
                            className="p-3 rounded shadow-sm mb-3 tarjeta-hover"
                            style={{
                                backgroundColor: '#fff',
                                color: '#343a40',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                cursor: 'pointer', // Indica que se puede hacer clic
                            }}
                            onClick={() => handleShow(3)} // Evento para toda la tarjeta
                        >

                            <div className="d-flex justify-content-between align-items-center">



                                <div>
                                    <h5 className="fw-bold m-0">Total proyectos</h5>
                                    <p className="fs-4 fw-bold m-0">
                                        {!error ? estadisticas.totalProyectos : "Datos no disponibles"}
                                    </p>
                                </div>
                                <FaSearch
                                    size={24}
                                    title="Ver detalles"
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s',
                                    }}
                                    onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                    onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                />
                            </div>
                        </div>


                        <div className="row">
                            {/* Primera tarjeta */}

                            {filtroActivo !== 2 && (
                                <div className="col-md-12 mb-3">
                                    <div
                                        className="card"
                                        style={{
                                            backgroundColor: '#dee2e6',
                                            color: '#f69d05',
                                        }}
                                    >
                                        {/* Header de la tarjeta */}
                                        <div className="card-header d-flex justify-content-between align-items-center tarjeta-hover" style={{ backgroundColor: '#FFF' }}>
                                            <h6 className="fw-bold m-0">
                                                Proyectos Nuevos: {!mostrarBody && (!error ? estadisticas.proyectosNuevos : "Datos no disponibles")}
                                            </h6>

                                            <div className="d-flex align-items-center gap-3">
                                                {/* Ícono de búsqueda */}
                                                <FaSearch
                                                    size={24}
                                                    className="cursor-pointer"
                                                    onClick={() => handleShow(1)}
                                                    title="Ver detalles"
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'transform 0.2s',
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                                    onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                                />
                                                {/* Ícono de filtro */}
                                                {!(filtroMunicipios || filtroEntidades || filtroSubregiones) && (
                                                    <CheckCircleOutlined
                                                        onClick={() => toggleFiltro(1)}
                                                        title={filtroActivo === 1 ? "Desactivar filtro" : "Activar filtro"}
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "20px",
                                                            transition: "transform 0.2s",
                                                            color: isActive ? "green" : "gray",
                                                        }}
                                                    />
                                                )}
                                                {/* Ícono para mostrar/ocultar */}
                                                <div
                                                    onClick={() => setMostrarBody((prev) => !prev)} // Cambia el estado
                                                    style={{ cursor: "pointer" }}
                                                    title={mostrarBody ? "Ocultar detalles" : "Mostrar detalles"}
                                                >
                                                    {mostrarBody ? (
                                                        <i className="bi bi-chevron-up"></i> // Ícono de Bootstrap
                                                    ) : (
                                                        <i className="bi bi-chevron-down"></i>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Cuerpo de la tarjeta */}
                                        {mostrarBody && ( // Renderiza el cuerpo solo si `mostrarBody` es true
                                            <div className="card-body" style={{ backgroundColor: '#FFF' }}>
                                                {/* Estadísticas generales */}
                                                <p className="fs-2 fw-bold m-0 text-center">
                                                    {!error ? estadisticas.proyectosNuevos : "Datos no disponibles"}
                                                </p>
                                                <hr />
                                                {/* Detalle de estado de proyectos */}
                                                <div>
                                                    {/* En ejecución */}
                                                    <div style={{ marginTop: "10px", paddingLeft: "10px", borderLeft: "4px solid #f69d05" }}>

                                                        <h5 style={{ marginBottom: "8px" }}>En ejecución: {!error ? estadisticas.nuevosEnEjecucion : "Datos no disponibles"}</h5>
                                                    </div>
                                                    <hr />
                                                    {/* Sin ejecución */}
                                                    <div style={{ marginTop: "10px", paddingLeft: "10px", borderLeft: "4px solid #f69d05" }}>
                                                        <h5 style={{ marginBottom: "8px" }}>Sin ejecución: {!error ? estadisticas.nuevosSinEjecucion : "Datos no disponibles"}</h5>
                                                        <ul style={{ paddingLeft: "20px", listStyleType: "disc", color: "#555" }}>
                                                            <li>
                                                                <h6 style={{ margin: 0 }}>Con apropiación: {!error ? estadisticas.nuevosConApropiacion : "Datos no disponibles"}</h6>
                                                            </li>
                                                            <li>
                                                                <h6 style={{ margin: 0 }}>Sin apropiación: {!error ? estadisticas.nuevosSinApropiacion : "Datos no disponibles"}</h6>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                        )}

                                        {/* Footer de la tarjeta */}
                                        <div className="card-footer text-center" style={{ backgroundColor: '#FFF' }}>
                                            <h6 className="fw-bold m-0">Inversión proyectos Nuevos</h6>
                                            <p className="fs-4 fw-bold m-0">
                                                ${!error ? Math.round(estadisticas.inversionProyectosNuevos).toLocaleString() : "Datos no disponibles"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Segunda tarjeta */}
                            {filtroActivo !== 1 && (
                                <div className="col-md-12 mb-3">
                                    <div
                                        className="card tarjeta-bg"
                                    >
                                        {/* Header de la tarjeta */}
                                        <div className="card-header d-flex justify-content-between align-items-center tarjeta-bg tarjeta-hover tarjeta-color1">
                                            <h6 className="fw-bold m-0">
                                                Otras vigencias: {!mostrarBodyO && (!error ? estadisticas.otrasVigencias : "Datos no disponibles")}
                                            </h6>

                                            <div className="d-flex align-items-center gap-2 ">
                                                {/* Ícono de búsqueda */}
                                                <FaSearch
                                                    size={24}
                                                    className="cursor-pointer"
                                                    onClick={() => handleShow(2)}
                                                    title="Ver detalles"
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'transform 0.2s',
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                                    onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                                />
                                                {/* Ícono de filtro */}
                                                {!(filtroMunicipios || filtroEntidades || filtroSubregiones) && (
                                                    <CheckCircleOutlined
                                                        onClick={() => toggleFiltro(2)}
                                                        title={filtroActivo === 2 ? "Desactivar filtro" : "Activar filtro"}
                                                        style={{
                                                            cursor: "pointer",
                                                            fontSize: "20px",
                                                            transition: "transform 0.2s",
                                                            color: isActive ? "green" : "gray",
                                                        }}
                                                    />
                                                )}
                                                {/* Ícono para mostrar/ocultar */}
                                                <div
                                                    onClick={() => setMostrarBodyO((prev) => !prev)} // Cambia el estado
                                                    style={{ cursor: "pointer" }}
                                                    title={mostrarBodyO ? "Ocultar detalles" : "Mostrar detalles"}
                                                >
                                                    {mostrarBodyO ? (
                                                        <i className="bi bi-chevron-up"></i> // Ícono de Bootstrap
                                                    ) : (
                                                        <i className="bi bi-chevron-down"></i>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Cuerpo de la tarjeta */}
                                        {mostrarBodyO && ( // Renderiza el cuerpo solo si `mostrarBody` es true
                                            <div className="card-body tarjeta-color1">
                                                {/* Estadísticas generales */}
                                                <p className="fs-2 fw-bold m-0 text-center">
                                                    {!error ? estadisticas.otrasVigencias : "Datos no disponibles"}
                                                </p>
                                                <hr />
                                                {/* Detalle de estado de proyectos */}
                                                <div>
                                                    {/* En ejecución */}
                                                    <div style={{ marginTop: "10px", paddingLeft: "10px", borderLeft: "4px solid #444242" }}>
                                                        <h5 style={{ marginBottom: "8px" }}>En ejecución: {!error ? estadisticas.otrasEnEjecucion : "Datos no disponibles"}</h5>
                                                    </div>
                                                    <hr />
                                                    {/* Sin ejecución */}
                                                    <div style={{ marginTop: "10px", paddingLeft: "10px", borderLeft: "4px solid #444242" }}>
                                                        <h5 style={{ marginBottom: "8px" }}>Sin ejecución: {!error ? estadisticas.otrasSinEjecucion : "Datos no disponibles"}</h5>
                                                        <ul style={{ paddingLeft: "20px", listStyleType: "disc", color: "#555" }}>
                                                            <li>
                                                                <h6 style={{ margin: 0 }}>Con apropiación: {!error ? estadisticas.otrasConApropiacion : "Datos no disponibles"}</h6>
                                                            </li>
                                                            <li>
                                                                <h6 style={{ margin: 0 }}>Sin apropiación: {!error ? estadisticas.otrasSinApropiacion : "Datos no disponibles"}</h6>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Footer de la tarjeta */}
                                        <div className="card-footer text-center tarjeta-bg tarjeta-color1">
                                            <h6 className="fw-bold m-0">Inversión Otras Vigencias</h6>
                                            <p className="fs-4 fw-bold m-0">
                                                ${!error ? Math.round(estadisticas.inversionOtrasVigencias).toLocaleString() : "Datos no disponibles"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>

                        {!filtroActivo && (
                            <div className="p-3 rounded mb-3 text-center tarjeta-bg" style={{ border: 'solid 1px #adb5bd', color: '#212529', fontSize: '16px' }}>
                                <h5 className="fw-bold m-0">Inversión total</h5>
                                <p className="fs-4 fw-bold m-0" style={{ fontSize: '2em' }}>

                                    ${!error ? Math.floor(estadisticas.inversionTotal).toLocaleString() : "Datos no disponibles"}

                                </p>
                            </div>
                        )}

                        {!(filtroMunicipios || filtroSubregiones) && (

                            <div
                                className="p-3 rounded mb-3 tarjeta-hover"
                                style={{ border: 'solid 1px #adb5bd', color: '#212529', fontSize: '16px' }}
                                onClick={() => handleShow(4)} // Evento onClick aplicado al card completo
                            >
                                <div className="d-flex justify-content-between align-items-center text-center" >
                                    {/* Primera columna: Texto y valor alineados */}
                                    <div>
                                        <h6 className="fw-bold m-0">Proyectos regionales (Cauca)</h6>
                                        <p className="fs-4 fw-bold m-0">
                                            {!error ? estadisticas.proyectosRegion.toLocaleString() : "Datos no disponibles"}
                                        </p>
                                    </div>

                                    {/* Segunda columna: Lupa centrada */}
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            transition: 'transform 0.2s',
                                        }}
                                    >
                                        <FaSearch
                                            size={24}
                                            title="Ver detalles"
                                            onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                            onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                        />
                                    </div>
                                </div>
                            </div>


                        )}


                        <div
                            className="p-3 rounded shadow-sm tarjeta-hover"
                            style={{ background: '#dee2e6', cursor: 'pointer' }} // Añade cursor para indicar que es clicable
                            onClick={handleShowG} // Evento onClick aplicado a todo el card
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center', // Alinear verticalmente
                                    gap: '8px', // Espacio entre el texto y el icono
                                }}
                            >
                                <h5 className="fw-bold text-center m-0">Indicadores</h5>
                                <BiBarChart
                                    size={24}
                                    title="Ver detalles"
                                    style={{
                                        transition: 'transform 0.2s',
                                    }}
                                    onMouseEnter={(e) => (e.target.style.transform = 'scale(1.2)')}
                                    onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                />
                            </div>
                        </div>


                    </div>

                </div>





                {/* Modal de ANT */}
                <Modal
                    title="Proyectos de Inversión"
                    open={showModal}
                    onCancel={handleClose}
                    footer={[
                        <Button key="close" type="default" onClick={handleClose}>
                            Cerrar
                        </Button>,
                    ]}
                    width="90vw" // Establece el ancho del modal
                    style={{ maxHeight: "80vh", overflowY: "auto" }} // Scroll interno en el cuerpo
                    centered
                >

                    <Button
                        type="default"
                        icon={<QuestionCircleOutlined />}
                        onClick={toggleVisibility}
                        className="hover-button"

                        style={{
                            backgroundColor: '#198754',
                            marginLeft: '10px',
                            cursor: 'pointer',
                            marginBottom: '10px',
                            color: visible ? 'orange' : 'white', // Cambio de color opcional
                        }}
                    >
                        Resumen
                    </Button>


                    <Button
                        type="default"
                        icon={<QuestionCircleOutlined />}
                        onClick={handleShowI}
                        className="hover-button"
                        style={{ backgroundColor: '#198754', color: '#FFF', marginLeft: '10px' }}
                    >
                        Indicaciones
                    </Button>


                    <div>
                        {/* Contenedor que muestra el resumen */}
                        {visible && (
                            <div
                                style={{
                                    width: '100%', // Define el ancho de la tabla
                                    margin: '0 auto 20px', // Centra horizontalmente el div
                                }}
                            >
                                {error && <p>{error}</p>}
                                {!error && (
                                    <div>
                                        {renderResumenProyectos()}
                                    </div>

                                )}
                            </div>
                        )}
                    </div>


                    <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
                        <TablaProyectos data={filteredData} />
                    </div>
                </Modal>

                <Modal
                    title="Gráficos - Inversiones en Proyectos"
                    open={showModalG}
                    onCancel={handleCloseG}
                    footer={[
                        <Button key="close" type="default" onClick={handleCloseG}>
                            Cerrar
                        </Button>,
                    ]}
                    width="90vw" // Establece el ancho del modal
                    style={{ maxHeight: "80vh", overflowY: "auto" }} // Scroll interno en el cuerpo
                    centered
                >

                    <div
                        style={{
                            width: '100%', // Usa el ancho completo para dispositivos pequeños
                            maxWidth: '600px', // Limita el ancho máximo en pantallas grandes
                            margin: '0 auto', // Centra el contenido
                            padding: '10px', // Añade espaciado interno
                            boxSizing: 'border-box', // Incluye el padding en el ancho
                        }}
                    >
                        {error && <p>{error}</p>}
                        {!error && (

                            <div>
                                {renderResumenProyectos()}
                            </div>

                        )}
                    </div>



                    <GraficosInversion data={proyectos} />


                </Modal>


                <Modal
                    title="Mapa de inversiones | Indicaciones "
                    open={isModalVisible}
                    onCancel={handleCloseI}
                    footer={[
                        <Button key="close" type="default" onClick={handleCloseI}>
                            Cerrar
                        </Button>,
                    ]}
                    width="90%" // Ajusta el ancho por defecto para pantallas más grandes
                    style={{
                        maxWidth: '500px', // Máximo ancho en pantallas grandes
                        maxHeight: "80vh",
                        overflowY: "auto",
                        top: "10px", // Define que el modal comience cerca de la parte superior
                        margin: '0 auto', // Centra el modal horizontalmente
                    }}

                >
                    <div
                        style={{
                            width: '100%', // Define el ancho del contenido
                            margin: '0 auto 20px', // Centra horizontalmente el div
                        }}
                    >
                        <ul style={{ paddingLeft: '20px', lineHeight: '1.6', fontSize: '14px', color: '#333' }}>
                            <li>
                                <strong>Fuente de datos:</strong> Los valores reportados corresponden al
                                <strong> reporte de ejecución presupuestal del año 2024</strong> proporcionado por la
                                <strong> Secretaría de Hacienda</strong>, basado en información obtenida del
                                <strong> Sistema de Información Administrativo y Financiero</strong>.
                            </li>
                            <li>
                                <strong>Clasificación de proyectos según vigencias:</strong>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>
                                        <strong>Proyectos Nuevos:</strong> Son aquellos proyectos cuya
                                        <strong> vigencia inicial es igual o superior a 2024</strong>.
                                    </li>
                                    <li>
                                        <strong>Otras Vigencias:</strong> son proyectos con
                                        <strong> vigencia inicial menor a 2024 y vigencia final mayor igual 2024</strong>.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <strong>Cálculo de inversión por municipio:</strong> La inversión total en un municipio incluye los proyectos que tienen una
                                <strong> inversión directa, grupal o regional</strong> en dicho municipio.
                            </li>
                            <li>
                                <strong>Estados de los proyectos:</strong>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>
                                        <strong>Proyectos sin apropiación:</strong> proyectos viables sin asignación presupuestal.
                                    </li>
                                    <li>
                                        <strong>Proyectos con apropiación:</strong> Proyectos con asignación presupuestal pero aún no ejecutados.
                                    </li>
                                    <li>
                                        <strong>Proyectos en ejecución:</strong> proyectos viables que cuentan consignación presupuestal y están siendo ejecutados.
                                    </li>
                                </ul>
                            </li>

                        </ul>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center', // Alinear verticalmente
                                color: '#052c65',
                                textAlign: 'center'
                            }}
                        ><strong>Fuente: Banco de proyectos - Grupo inversión y finanzas públicas - Gobernación del Cauca</strong></div>

                    </div>
                </Modal>




            </div >

        </>
    );

};

export default MapaCauca;
